import { render } from "./TableOfContent.vue?vue&type=template&id=bd14595a"
import script from "./TableOfContent.vue?vue&type=script&lang=js"
export * from "./TableOfContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__